import { PunchupBoxOffice } from 'features/PunchupPages/PunchupBoxOffice';

const PunchupBoxOfficePage = (): JSX.Element => <PunchupBoxOffice />;

export default PunchupBoxOfficePage;
